import adminData from '../data/admin-data.json';

const TIER_ORDER = ['free', 'season_pass', 'navigator', 'tactician'];
const TIER_LABELS = {
  free: 'Free',
  season_pass: 'Sailor',
  navigator: 'Navigator',
  tactician: 'Tactician',
};

const COMPONENT_PREFIXES = [
  'mark_icons_contact_card',
  'rounding_direction_contact_card',
  'nav_header_contact_card',
  'prev_next_buttons_contact_card',
];

function isComponentScreenshot(prefix) {
  return COMPONENT_PREFIXES.includes(prefix);
}

/** Parse capabilities into tier groups with partitioned items. */
export function loadFeatures() {
  const caps = adminData.capabilities;
  const counts = { ui: 0, compile: 0, none: 0 };
  const tiers = [];

  for (const tier of TIER_ORDER) {
    const list = caps[tier];
    if (!list || !list.length) continue;

    list.forEach((c) => counts[c.gating]++);

    const screens = [];
    const components = [];
    const noScreenshot = [];

    list.forEach((cap) => {
      if (cap.screenshot && isComponentScreenshot(cap.screenshot)) {
        components.push(cap);
      } else if (cap.screenshot) {
        screens.push(cap);
      } else {
        noScreenshot.push(cap);
      }
      if (cap.children) {
        cap.children.forEach((child) => {
          if (child.screenshot) components.push(child);
        });
      }
    });

    tiers.push({ tier, label: TIER_LABELS[tier], screens, components, noScreenshot });
  }

  const total = counts.ui + counts.compile + counts.none;
  return { tiers, counts, total };
}
